import React, { forwardRef, useState, useEffect, useRef } from "react";
import { Breadcrumb } from "components";
import { translate } from "react-switch-lang";
import { AddBox, ArrowDownward } from "@material-ui/icons";
import { User, List } from "react-feather";
import { Spinner } from "reactstrap";
import MaterialTable from "material-table";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import api from "components/api/api";
import TargetPerPlanChart from "./hbbChart/TargetPerPlanChart";
import {
  getPayout,
  getTarget,
  getHBB,
  getHayyak,
  getBaqati,
  getUpgrade,
  getRegionPer,
  getOutletByName,
  getTargetPerPlan,
} from "../../service/inentiveService";
import FlowerChart from "./flowerChart";
import ClusteredAmChart from "./clustered";
import TraingleChart from "./traingleColumnChart";
import UpgradeChart from "./upgradeChart";
import PropTypes from "prop-types";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Box from "@material-ui/core/Box";
import Swal from "sweetalert2";
import {
  POSITIONS,
  POSITIONS_LABEL,
  QUARTERS_VALUE,
} from "../../constant/variables";
import { getCurrentYear } from "utils/date";
import PositionFilters from "./positionFilters";
import Loader from "components/loader";
import { getOutletRegion } from "utils";
import YearsDropdown from "components/dropdown/yearsDropdown";
import QuarterMonthsDropdown from "components/dropdown/quarterMonthsDropdown";
import BulletPieRegion from "pages/amCharts/bulletPiechart";
import BulletPieChartOutlet from "pages/amCharts/bulletPiechartOutlet";
import { getEmployeePer, getOutletPer } from "service/dashboardService";
import EmployeeTargetChart from "pages/amCharts/employeeTargetChart";
import TraingleColumnChartHbb from "./hbbChart/traingleColumnChartHbb";
import axiosService from "service/axios-service";
import CheckboxDropdown from "components/dropdown/CheckboxDropdown";
import ScoreBoardPieChart from "./ScoreBoardPieChart";
import ScoreBoardTable from "./ScoreBoardTable";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const capitalize = (val = "") => {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StaffPerNew = (props) => {
  const { isMyPerformance } = props;
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({});
  const [month, setMonth] = useState("1Q");
  const [year, setYear] = useState(getCurrentYear());
  const [voc_score, setVoc_score] = useState(0);
  const [quiz_score, setQuiz_score] = useState(0);
  const [quizData, setQuizData] = useState([]);
  const [value, setValue] = React.useState(0);
  const [salesScore, setSalesScore] = useState(0);

  const [targetData, setTargetData] = useState();
  const [scoreLoading, setScoreLoading] = useState(false);
  const [targetDataLoading, setTargetDataLoading] = useState(false);
  const [hbbData, setHbbData] = useState(null);
  const [hbbDataLoading, setHbbDataLoading] = useState(false);
  const [hayyakData, setHayyakData] = useState(null);
  const [hayyakDataLoading, setHayyakDataLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [baqatiData, setBaqatiData] = useState(null);
  const [baqatiDataLoading, setBaqatiDataLoading] = useState(false);
  const [upgradeData, setUpgradeData] = useState([]);
  const [upgradeDataLoading, setUpgradeDataLoading] = useState(false);
  const [regionper, setRegionper] = useState([]);
  const [regionperLoading, setRegionperLoading] = useState(false);
  const [viewFilter, setViewFilter] = useState(true);
  const [targetPerPlanData, setTargetPerPlanData] = useState({
    PREMIUM: null,
    STANDARD: null,
  });
  const [targetPerPlanLoading, setTargetPerPlanLoading] = useState(false);

  const [selectedRegion, setSelectedRegion] = useState("");
  const [outletper, setOutletper] = useState([]);
  const [outletperLoading, setOutletperLoading] = useState(false);
  const [empperLoading, setEmpperLoading] = useState(false);
  const [empper, setEmpper] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState("");
  const [isQuarterSelected, setIsQuarterSelected] = useState(false);
  const [categoryPlans, setCategoryPlans] = useState(null);
  const [allValue, setAllValue] = useState("all");
  const [allValueLabel, setAllValueLabel] = useState("All");
  const [valueToDisplay, setValueToDisplay] = useState(allValueLabel);

  const [MNPlabel, setMNPlabel] = useState([]);
  const [hayyakLable, setHayyakLabel] = useState([]);
  const [baqatiLable, setBaqatiLabel] = useState([]);
  const [baqatiPlan, setBaqatiPlan] = useState([]);
  const [hayyakPlan, setHayyakPlan] = useState([]);
  const [MNPTotal, setMNPTotal] = useState(0);

  var OwnerPosition = JSON.parse(localStorage.getItem("Position"));
  var isAdmin = localStorage.getItem("is_admin");
  const allowedPositions = ["M", "SM", "GM", "VP"];
  const getHidePayout = (position = OwnerPosition) => {
    return (
      position === POSITIONS.VICE_PRESIDENT ||
      position === POSITIONS.GENERAL_MANAGER
    );
  };
  // const SALES_BENCHMARK = targetData?.target || 100;
  // console.log(
  //   "🚀 ~ file: index.js:427 ~ StaffPerNew ~ SALES_BENCHMARK:",
  //   SALES_BENCHMARK
  // );
  // const computedSalesScore =
  //   (hayyakData?.total || 0) +
  //   (baqatiData?.total || 0) +
  //   (hbbData?.total || 0) +
  //   (upgradeData?.total || 0) +
  //   (MNPTotal || 0);
  const calculateSalesScore = (targetData) => {
    if (!targetData) return 0;

    const products = ["Hayyak", "Baqati", "HBB", "Upgrade"];

    const percentages = products.map(
      (p) => targetData[p]?.achieved_percentage ?? 0,
    );

    const avg = percentages.reduce((sum, v) => sum + v, 0) / percentages.length;

    return Math.round(avg);
  };

  const getTargetPerPlanData = async () => {
    const filterPositionId = isMyPerformance
      ? null
      : positionFilterRef.current.getPositionClientId();
    const apiId = filterPositionId || client_id;

    setTargetPerPlanLoading(true);
    try {
      const [premiumRes, standardRes] = await Promise.all([
        getTargetPerPlan(apiId, month, year, allValue, "PREMIUM"),
        getTargetPerPlan(apiId, month, year, allValue, "STANDARD"),
      ]);
      setTargetPerPlanData({ PREMIUM: premiumRes, STANDARD: standardRes });
    } catch (err) {
      console.error("Error fetching target per plan:", err);
    } finally {
      setTargetPerPlanLoading(false);
    }
  };

  // const SingleScore = scoreLoading
  //   ? 0
  //   : Number(singleScore) + computedSalesScore;
  const SingleScore = Math.round(
    salesScore * 0.4 + quiz_score * 0.3 + voc_score * 0.3,
  );

  const fetchSingleScore = async () => {
    try {
      const filterPositionId = isMyPerformance
        ? null
        : positionFilterRef.current.getPositionClientId();

      let apiId = filterPositionId || client_id;

      setScoreLoading(true);

      // Convert 1Q → Q1, 2Q → Q2, etc.
      const formattedQuarter = getIsQuarter()
        ? `Q${month.replace("Q", "")}`
        : null;

      const res = await api.getSurveyScoreByStaffId(
        apiId,
        formattedQuarter,
        year,
      );

      if (res?.data?.success) {
        setQuiz_score(res.data.data?.quizScore || 0);
        setQuizData(res.data.data?.quizData || []);
      }
    } catch (err) {
      console.error("Failed to fetch single score", err);
    } finally {
      setScoreLoading(false);
    }
  };
  const filterData = (data) => {
    let total = 0;
    const label = [];
    const ebuLabel = [];
    const cbuLabel = [];
    const ebuPlans = [];
    const cbuPlans = [];
    // HBB
    const cbuCategoryLabel = [];
    const ebuCategoryLabel = [];
    const subcateries = {};
    const hbbPlans = {};
    const serviceCbuHbb = [];
    const serviceEbuHbb = [];
    let serviceCbuTotal = 0;
    let serviceEbuTotal = 0;

    for (let key in data?.businessUnit) {
      if (data?.businessUnit?.hasOwnProperty(key)) {
        total = total + data?.businessUnit?.[key]?.count;
        label.push({
          country: capitalize(key),
          litres: data?.businessUnit?.[key]?.count,
        });
      }
    }
    if (data?.product == "HAYYAK" || data?.product == "BAQATI") {
      for (let key in data?.subCategory?.CBU) {
        if (key != "total" && data?.subCategory?.CBU?.hasOwnProperty(key)) {
          cbuLabel.push({
            country: key,
            litres: data?.subCategory?.CBU?.[key]?.count,
          });
        }
      }

      for (let key in data?.subCategory?.EBU) {
        if (key != "total" && data?.subCategory?.EBU?.hasOwnProperty(key)) {
          ebuLabel.push({
            country: key,
            litres: data?.subCategory?.EBU?.[key]?.count,
          });
        }
      }

      for (let key in data?.plans?.CBU) {
        if (data?.plans?.CBU?.hasOwnProperty(key)) {
          cbuPlans.push({
            plan: key,
            total_sales: data?.plans?.CBU?.[key],
            bold: key == "total",
          });
        }
      }

      for (let key in data?.plans?.EBU) {
        if (data?.plans?.EBU?.hasOwnProperty(key)) {
          ebuPlans.push({
            plan: key,
            total_sales: data?.plans?.EBU?.[key],
            bold: key == "total",
          });
        }
      }
    }

    if (data?.product === "HBB") {
      for (let key in data?.category) {
        if (key?.includes("CBU")) {
          cbuCategoryLabel.push({
            country: key,
            litres: data?.category?.[key]?.count,
            type: "CBU",
          });
        } else {
          ebuCategoryLabel.push({
            country: key,
            litres: data?.category?.[key]?.count,
            type: "EBU",
          });
        }
      }

      let cbuTotal = 0;
      let ebuTotal = 0;

      for (let key in data?.subCategory) {
        let list = [];

        for (let subkey in data?.subCategory?.[key]) {
          if (subkey != "total") {
            if (key == "CBU WFBB") {
              cbuTotal = cbuTotal + data?.subCategory?.[key][subkey]?.count;
            }
            if (key == "EBU WFBB") {
              ebuTotal = ebuTotal + data?.subCategory?.[key][subkey]?.count;
            }
            list.push({
              country: subkey,
              litres: data?.subCategory?.[key][subkey]?.count,
            });
          }
        }

        subcateries[key] = list;
        subcateries["cbuTotal"] = cbuTotal;
        subcateries["ebuTotal"] = ebuTotal;
      }

      for (let key in data?.serviceCategory) {
        if (key == "CBU HBB") {
          serviceCbuTotal = data?.serviceCategory?.[key]?.total ?? 0;

          for (let subkey in data?.serviceCategory?.[key]) {
            if (
              subkey == "total" ||
              subkey == "Voice only" ||
              subkey == "percent"
            ) {
              continue;
            }

            serviceCbuHbb.push({
              country: subkey,
              litres: data?.serviceCategory?.[key][subkey]?.count,
            });
          }
        } else if (key == "EBU HBB") {
          serviceEbuTotal = data?.serviceCategory?.[key]?.total ?? 0;
          for (let subkey in data?.serviceCategory?.[key]) {
            if (
              subkey == "total" ||
              subkey == "Voice only" ||
              subkey == "percent"
            ) {
              continue;
            }
            serviceEbuHbb.push({
              country: subkey,
              litres: data?.serviceCategory?.[key][subkey]?.count,
            });
          }
        }
      }

      for (let key in data?.plans) {
        let list = [];
        for (let subkey in data?.plans?.[key]) {
          list.push({
            plan: subkey,
            total_sales: data?.plans?.[key][subkey],
            bold: subkey == "total",
          });
        }
        hbbPlans[key] = list;
      }
    }

    const filteredData = {
      product: data?.product,
      label,
      total,
      ebuLabel,
      cbuLabel,
      cbuPlans,
      ebuPlans,
      cbuCategoryLabel,
      ebuCategoryLabel,
      subcateries,
      serviceCbuHbb,
      serviceEbuHbb,
      hbbPlans,
      serviceCbuTotal,
      serviceEbuTotal,
    };

    if (data?.product == "HAYYAK") setHayyakData(filteredData);
    if (data?.product == "BAQATI") setBaqatiData(filteredData);
    if (data?.product == "HBB") setHbbData(filteredData);
  };

  const getIsQuarter = () => {
    return (
      month == QUARTERS_VALUE.Q1 ||
      month == QUARTERS_VALUE.Q2 ||
      month == QUARTERS_VALUE.Q3 ||
      month == QUARTERS_VALUE.Q4
    );
  };

  const [selectedPosition, setSelectedPosition] = useState(OwnerPosition);
  const [hidePayoutSection, setHidePayoutSection] = useState(getHidePayout());

  const positionFilterRef = useRef(null);

  const [isOM, setIsOM] = useState(OwnerPosition === POSITIONS.OUTLET_MANAGER);

  var Owner = localStorage.getItem("Name");
  var client_id = JSON.parse(localStorage.getItem("clientId"));

  const isAgent =
    OwnerPosition === POSITIONS.AGENT || selectedPosition === POSITIONS.AGENT;

  // let hidePayout = getHidePayout();
  let hidePayout = true;

  // if (!isMyPerformance) {
  //   hidePayout = hidePayoutSection;
  // }

  const getHayyakAndBaqatiData = async (product) => {
    const filterPositionId = isMyPerformance
      ? null
      : positionFilterRef.current.getPositionClientId();
    let apiId = filterPositionId || client_id;
    if (product == "HAYYAK") setHayyakDataLoading(true);
    if (product == "BAQATI") setBaqatiDataLoading(true);
    if (product == "HBB") setHbbDataLoading(true);
    await axiosService
      .post("/sales/incentive/usr_sales_count", {
        client_id: apiId,
        monthly: !getIsQuarter()
          ? `${Number(month) < 10 ? "0" + month : month}-${year}`
          : "",
        quarterly: getIsQuarter() ? `${month?.replace("Q", "")}-${year}` : "",
        product,
        channel: allValue,
      })
      .then((res) => {
        // console.log("usr_sales_count", res);
        if (product == "HAYYAK") setHayyakDataLoading(false);
        if (product == "BAQATI") setBaqatiDataLoading(false);
        if (product == "HBB") setHbbDataLoading(false);
        filterData(res?.data ?? {});
      })
      .catch((err) => {
        if (product == "HAYYAK") setHayyakDataLoading(false);
        if (product == "BAQATI") setBaqatiDataLoading(false);
        if (product == "HBB") setHbbDataLoading(false);
      });
  };

  const transformPlanData = (planData) => {
    if (!planData) return [];

    const result = [];
    let totalRow = { plan: "total", sub_total: 0, bold: true };

    Object.entries(planData).forEach(([planName, providers], idx) => {
      const row = {
        plan: planName,
        sub_total: 0,
        bold: false,
        tableData: { id: idx },
      };

      Object.entries(providers).forEach(([provider, count]) => {
        row[provider] = count;
        row.sub_total += count;
        totalRow[provider] = (totalRow[provider] || 0) + count;
      });

      totalRow.sub_total += row.sub_total;
      result.push(row);
    });

    result.push(totalRow);
    return result;
  };
  const transformMNPLabel = (saleData) => {
    if (!saleData) return [];

    return [
      { country: "Hayyak", litres: saleData.Hayyak?.count || 0 },
      { country: "Baqati", litres: saleData.Baqati?.count || 0 },
    ];
  };
  const PROVIDER_MAP = {
    OOREDOO: "Oredoo",
    VFOM: "Vodafone",
    RENNA: "Renna",
    NFND: "Friendi",
    "": "Other",
  };
  const transformProviderLabel = (typeData) => {
    if (!typeData) return [];
    return Object.keys(typeData).map((provider) => ({
      country: PROVIDER_MAP[provider] || provider || "Unknown", // ✅ map to label
      litres: typeData[provider]?.count || 0,
      rawKey: provider, // optional: keep raw API key if needed
    }));
  };
  //   if (!planData) return [];

  //   const result = [];
  //   let totalRow = { plan: "total", sub_total: 0, bold: true };

  //   Object.entries(planData).forEach(([planName, providers], idx) => {
  //     const row = {
  //       plan: planName,
  //       sub_total: 0,
  //       bold: false,
  //       tableData: { id: idx },
  //     };

  //     Object.entries(providers).forEach(([provider, count]) => {
  //       row[provider] = count;
  //       row.sub_total += count;
  //       totalRow[provider] = (totalRow[provider] || 0) + count;
  //     });

  //     totalRow.sub_total += row.sub_total;
  //     result.push(row);
  //   });

  //   result.push(totalRow);
  //   return result;
  // };
  const getScorePieData = () => {
    return [
      { category: "Sales", value: salesScore },
      { category: "VOC", value: voc_score },
      { category: "Quiz", value: quiz_score },
      { category: "Quality Assurance", value: data?.qa_score || 0 },
      { category: "Academy", value: data?.academy_score || 0 },
    ];
  };

  const getMNPPlanCount = async () => {
    try {
      const filterPositionId = isMyPerformance
        ? null
        : positionFilterRef.current.getPositionClientId();
      let apiId = filterPositionId || client_id;
      const planResponse = await axiosService.post(
        "/sales/incentive/usr_mnp_plan_count",
        {
          client_id: apiId,
          monthly: !getIsQuarter()
            ? `${Number(month) < 10 ? "0" + month : month}-${year}`
            : "",
          quarterly: getIsQuarter() ? `${month?.replace("Q", "")}-${year}` : "",
        },
      );
      setBaqatiPlan(transformPlanData(planResponse.data.Baqati));
      setHayyakPlan(transformPlanData(planResponse.data.Hayyak));

      // console.log("🌍 MNP Plan Count Response:", planResponse.data);
    } catch (err) {
      console.error("❌ Error fetching MNP Plan Count:", err);
    }
  };

  const getMNPSaleCount = async () => {
    try {
      const filterPositionId = isMyPerformance
        ? null
        : positionFilterRef.current.getPositionClientId();
      let apiId = filterPositionId || client_id;

      const saleResponse = await axiosService.post(
        "/sales/incentive/usr_mnp_sale_count",
        {
          client_id: apiId,
          monthly: !getIsQuarter()
            ? `${Number(month) < 10 ? "0" + month : month}-${year}`
            : "",
          quarterly: getIsQuarter() ? `${month?.replace("Q", "")}-${year}` : "",
        },
      );

      const data = saleResponse.data;
      const total = data?.total ?? 0;
      setMNPTotal(total);

      // Existing labels
      setMNPlabel(transformMNPLabel(data));
      setHayyakLabel(transformProviderLabel(data.Hayyak?.types));
      setBaqatiLabel(transformProviderLabel(data.Baqati?.types));

      // // ✅ New mapped provider rows for table
      // const hayyakProviders = transformProviders(data.Hayyak?.types);
      // const baqatiProviders = transformProviders(data.Baqati?.types);

      // setHayyakTable(hayyakProviders); // <-- use in your MaterialTable
      // setBaqatiTable(baqatiProviders);

      // console.log("🌍 MNP Sale Count Response:", data);
    } catch (err) {
      console.error("❌ Error fetching MNP Sale Count:", err);
    }
  };

  const getTabData = async () => {
    try {
      // Update the display label
      setHasSearched(true);
      setValueToDisplay(allValueLabel || "");

      // Fetch HAYYAK data first
      await getHayyakAndBaqatiData("HAYYAK");

      setValue(0);

      // Fetch remaining data
      await getHayyakAndBaqatiData("BAQATI");
      await getHayyakAndBaqatiData("HBB");
      await getMNPPlanCount();
      await getMNPSaleCount();
      await fetchSingleScore();

      // Trigger the submit handler
      handleSubmit();
      await getTargetPerPlanData();
    } catch (error) {
      console.error("Error fetching tab data:", error);
    }
  };

  const getCategoryPlans = (product) => {
    const filterPositionId = isMyPerformance
      ? null
      : positionFilterRef.current.getPositionClientId();
    let apiId = filterPositionId || client_id;

    axiosService
      .post("/sales/incentive/user_plan_category", {
        client_id: apiId,
        monthly: !getIsQuarter()
          ? `${Number(month) < 10 ? "0" + month : month}-${year}`
          : "",
        quarterly: getIsQuarter() ? `${month?.replace("Q", "")}-${year}` : "",
        product,
        channel: allValue,
      })
      .then(({ data }) => {
        // console.log("user_plan_category", data);
        setCategoryPlans(data);
      })
      .catch((err) => {
        console.error("user_plan_category error", err);
      });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleReset = () => {
    setYear(getCurrentYear());
    setMonth("1Q");
    if (!isMyPerformance) {
      positionFilterRef.current.reset();
    }
  };

  useEffect(() => {
    dropDown();
    // if(isMyPerformance) {
    //   handleSubmit();
    // }
  }, []);

  useEffect(() => {
    if (selectedOutlet) {
      getEmployeeTargetData();
    }
  }, [selectedOutlet]);

  const getEmployeeTargetData = async () => {
    setEmpperLoading(true);

    try {
      const outlet = await getOutletByName(selectedOutlet, "", month, year);
      // FIX ME - Fetch Outlet Manager Id Using Outlet Name
      // console.log("StaffPerformance getEmployeeTargetData", outlet);
      const outletManagerId = outlet.client_id || ""; // FIX ME
      getEmployee(outletManagerId.toString());
    } catch (err) {
      getEmployee("");
      console.error(err);
      // FIX ME
    }
  };

  const dropDown = async () => {
    if (OwnerPosition === "SM") {
      // setRegionchart(true)
    }
  };
  const handleSubmit = async () => {
    setSelectedRegion("");
    setSelectedOutlet("");
    let isOutletSelected = isOM;
    let isAgentSelected = OwnerPosition === POSITIONS.AGENT;

    // @ts-ignore
    const filterPositionId = isMyPerformance
      ? null
      : positionFilterRef.current.getPositionClientId();
    // @ts-ignore
    const selectedPosition = isMyPerformance
      ? null
      : positionFilterRef.current.getSelectedPosition();
    let isHidePayout = getHidePayout(selectedPosition);
    setIsQuarterSelected(getIsQuarter);
    if (!isMyPerformance) {
      isHidePayout = getHidePayout(selectedPosition);
      setHidePayoutSection(isHidePayout);
      setIsOM(selectedPosition === POSITIONS.OUTLET_MANAGER);
      isOutletSelected = selectedPosition === POSITIONS.OUTLET_MANAGER;
      isAgentSelected = selectedPosition === POSITIONS.AGENT;
    }
    // console.log("StaffPerformance handleSubmit", {
    //   filterPositionId,
    //   hidePayout,
    //   selectedPosition,
    // });

    setSelectedPosition(selectedPosition);

    if (!month) {
      Swal.fire({
        icon: "error",
        text: "Select quarter or month",
        timer: 1600,
      });
    } else if (!year) {
      Swal.fire({
        icon: "error",
        text: "Select year",
        timer: 1600,
      });
    } else {
      let apiId = filterPositionId || client_id;

      try {
        setUpgradeDataLoading(true);
        setTargetDataLoading(true);
        setOutletperLoading(true);

        if (!(isOutletSelected || isAgentSelected)) {
          setRegionperLoading(true);
        }

        if (isOM && isMyPerformance) {
          // setSelectedOutlet(outletName);
        }

        if (!isHidePayout) {
          setLoader(true);
          const res1 = await getPayout(apiId, month, year, allValue);
          setData(res1);
          setVoc_score(res1?.VOC?.payout || 30);
          setLoader(false);
        }
        const res2 = await getTarget(apiId, month, year, allValue);
        setTargetData(res2 || []);
        setSalesScore(calculateSalesScore(res2));

        setTargetDataLoading(false);

        if (!(isOutletSelected || isAgentSelected)) {
          const res8 = await getRegionPer(apiId, month, year);
          setRegionper(res8 || []);
          setRegionperLoading(false);
        }

        if (!isAgentSelected) {
          getOutlet(apiId);
        }

        const res6 = await getUpgrade(apiId, month, year, allValue);
        setUpgradeData(res6 || []);
        setUpgradeDataLoading(false);
      } catch (error) {
        console.error(error);
      }
      setLoader(false);
    }
  };

  const getOutlet = async (clientId = client_id) => {
    try {
      setOutletperLoading(true);
      const res = await getOutletPer(clientId, month, year, allValue);
      const selectedPosition = isMyPerformance
        ? OwnerPosition
        : positionFilterRef?.current?.getSelectedPosition();
      // console.log("StaffPerformance getOutlet", { res, selectedPosition });
      if (selectedPosition === POSITIONS.OUTLET_MANAGER) {
        const regionName = res[0] ? res[0].Region : "";
        // setSelectedOutlet(outletName);
        setSelectedRegion(regionName);
      }
      setOutletper(res || []);
    } catch (error) {
      console.error(error);
    } finally {
      setOutletperLoading(false);
    }
  };

  const getEmployee = async (clientId = client_id) => {
    try {
      setEmpperLoading(true);
      const res = await getEmployeePer(clientId, month, year);
      setEmpper(res && res.length ? res : []);
    } catch (error) {
      console.error(error);
    } finally {
      setEmpperLoading(false);
    }
  };

  const currentYear = new Date().getFullYear();

  const range = (start, stop, step) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (_, i) => start + i * step,
    );

  var yearDropdown = range(currentYear, currentYear - 1, -1);

  const handleViewFilter = () => {
    setViewFilter(!viewFilter);
  };

  const sumTotalQty = (data = []) => {
    return data.reduce((sum, current) => sum + Number(current.qty), 0);
  };

  const renderFilters = () => (
    <div className="col-md-4 col-sm-4 col-xs-12">
      <Paper
        style={{
          overflow: "hidden",
          marginTop: 10,
          padding: isMyPerformance ? 25 : 10,
          paddingTop: 25,
          paddingBottom: 25,
          textAlign: "center",
          minHeight: 170,
        }}
        className="dashboardDetailsStyle"
        elevation={5}
      >
        {isMyPerformance ? (
          <>
            <div>
              {isMyPerformance ? null : (
                <List className="svgListStyle" onClick={handleViewFilter} />
              )}
            </div>
            <div>
              <User className="svgStyle" />
            </div>
            <h4>
              {Owner} - {client_id}
            </h4>
            <h6>{POSITIONS_LABEL[OwnerPosition]}</h6>
            <h6>{getOutletRegion()}</h6>
          </>
        ) : (
          <PositionFilters
            t={props.t}
            ref={positionFilterRef}
            month={month}
            year={year}
            channel={allValue}
          />
        )}
      </Paper>
    </div>
  );

  const renderRegionwiseChart = () => {
    return (
      <Paper
        style={{
          overflow: "hidden",
          marginTop: 10,
          padding: 25,
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
        }}
        className="position-relative"
        elevation={5}
      >
        <BulletPieRegion
          key="region"
          regionsale={regionper}
          onSelect={setSelectedRegion}
          isMyPerformance={isMyPerformance}
        />
        {regionperLoading && <Loader />}
        <div id="outletProductChartId" />
      </Paper>
    );
  };

  const renderOutletwiseChart = () => {
    return (
      <Paper
        style={{
          overflow: "hidden",
          marginTop: 10,
          padding: 25,
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
        }}
        className="position-relative"
        elevation={5}
      >
        <BulletPieChartOutlet
          key="outlet"
          outletper={outletper}
          region={selectedRegion}
          onSelect={setSelectedOutlet}
          isMyPerformance={isMyPerformance}
          selectedRegion={selectedRegion}
        />
        {outletperLoading && <Loader />}
        <div id="employeeTargetId" />
      </Paper>
    );
  };

  const CHANNEL_LABELS = {
    direct: "Direct",
    franchise: "Selco",
    franchiseinfoline: "Infoline",
    "all-franchise": "Franchise",
    all: "All",
  };

  const renderEmployeewiseChart = () => {
    return (
      <Paper
        style={{
          overflow: "hidden",
          marginTop: 10,
          padding: 25,
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
        }}
        className="position-relative"
        elevation={5}
      >
        <div
          style={{
            display: "flex",
            alignSelf: "baseline",
            width: "100%",
            padding: 30,
          }}
        ></div>
        <EmployeeTargetChart
          outletper={empper}
          outlet={selectedOutlet}
          isMyPerformance={isMyPerformance} // ← add
          selectedOutlet={selectedOutlet}
        />
        {empperLoading && <Loader />}
      </Paper>
    );
  };
  return (
    <>
      <Breadcrumb
        title={props.t(
          isMyPerformance ? "My Performance" : "Staff Performance",
        )}
      />
      <div className="app-wrapper" style={{}}>
        <div className="animated slideInUpTiny animation-duration-3">
          <div className="row dashboardDetails">
            {!isMyPerformance ? null : renderFilters()}
            <div
              className={
                viewFilter
                  ? "col-md-8 col-sm-8 col-xs-12 viewFilter"
                  : "col-md-8 col-sm-8 col-xs-12"
              }
            >
              <Paper
                style={{ overflow: "hidden", marginTop: 10, padding: 25 }}
                elevation={5}
              >
                <div className="row" style={{ display: "flex" }}>
                  <div className="col-md-6 col-sm-12">
                    <div className="row">
                      <QuarterMonthsDropdown
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="row">
                      <YearsDropdown
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                        className="col-md-12 col-sm-12"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="row">
                      {(allowedPositions.includes(OwnerPosition) ||
                        isAdmin) && (
                        <CheckboxDropdown
                          setValue={(val) => {
                            setAllValueLabel(CHANNEL_LABELS[val] || val); // store UI label
                            console.log(
                              "setAllValueLabel",
                              CHANNEL_LABELS[val],
                            );
                            setAllValue(val); // store API value
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="row pt-5">
                      <div className="col-md-4 col-sm-6">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            // handleSubmit();
                            getTabData();
                          }}
                          style={{ marginRight: 10, height: 36, width: 80 }}
                        >
                          {loader || targetDataLoading ? (
                            <Spinner size="sm" />
                          ) : (
                            props.t("search")
                          )}
                        </Button>
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleReset}
                          style={{ height: 36, width: 80 }}
                        >
                          {props.t("Reset")}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Paper>
            </div>
            {isMyPerformance ? null : renderFilters()}
            {/* <div className="col-md-4 col-sm-4 col-xs-12">
                <Paper
                  style={{
                    overflow: "hidden",
                    marginTop: 10,
                    padding: isMyPerformance ? 25 : 10,
                    paddingTop: 25,
                    paddingBottom: 25,
                    textAlign: "center",
                    minHeight: 170,
                  }}
                  className="dashboardDetailsStyle"
                  elevation={5}
                >
                  {isMyPerformance ? <>
                  <div>
                    {isMyPerformance ? null : <List className="svgListStyle" onClick={handleViewFilter} />}
                  </div>
                  <div>
                    <User className="svgStyle" />
                  </div>
                  <h4>{Owner}</h4>
                  <h6>{POSITIONS_LABEL[OwnerPosition]}</h6>
                  </> : <PositionFilters t={props.t} ref={positionFilterRef} month={month} year={year} />}
                </Paper>
              </div> */}
          </div>
        </div>
        <div className="animated slideInUpTiny animation-duration-3 tabUI_Style">
          <div className="row">
            <div className="col-12">
              <Paper
                style={{ overflow: "hidden", marginTop: 10, padding: 25 }}
                elevation={5}
              >
                <div className="row" style={{ display: "block" }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example tabUI_StyleTabs"
                  >
                    <Tab label={valueToDisplay} {...a11yProps(0)} />

                    <Tab
                      label={`Hayyak (${hayyakData?.total ?? 0})`}
                      {...a11yProps(1)}
                    />
                    <Tab
                      label={`Baqati (${baqatiData?.total ?? 0})`}
                      {...a11yProps(2)}
                    />
                    <Tab
                      label={`HBB (${hbbData?.total ?? 0})`}
                      {...a11yProps(3)}
                    />

                    <Tab
                      label={`Upgrade (${
                        upgradeData ? sumTotalQty(upgradeData) : 0
                      })`}
                      {...a11yProps(5)}
                    />
                    <Tab label={`MNP (${MNPTotal ?? 0})`} {...a11yProps(4)} />
                    <Tab label={`Score Board`} {...a11yProps(6)} />
                  </Tabs>
                </div>
              </Paper>
            </div>
          </div>
        </div>
        <div className="animated slideInUpTiny animation-duration-3">
          {/* {data && !loader ? ( */}
          <>
            <TabPanel value={value} index={0} className="tabPanelUI_style">
              {!hasSearched && (
                <Paper
                  style={{
                    overflow: "hidden",
                    marginTop: 10,
                    padding: 25,
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  className="position-relative"
                  elevation={5}
                >
                  <div
                    style={{
                      display: "flex",
                      alignSelf: "baseline",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography variant="h5" component="h3">
                      {"All"}
                    </Typography>
                  </div>
                </Paper>
              )}
              {hidePayout || !isQuarterSelected ? null : (
                <Paper
                  style={{
                    overflow: "hidden",
                    marginTop: 10,
                    padding: 25,
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  className="position-relative"
                  elevation={5}
                >
                  <Paper style={{ padding: 15, marginBottom: 30 }}>
                    <Typography variant="h5" component="h3">
                      {props.t("Total Payout(OMR)")}
                      &nbsp;&nbsp;&nbsp;&nbsp; {data.total_pay}
                    </Typography>
                  </Paper>
                  <FlowerChart
                    showVoc={month === "4Q"}
                    data={data}
                    isMyPerformance={isMyPerformance}
                  />{" "}
                  {loader && <Loader />}
                </Paper>
              )}
              {hasSearched && (
                <Paper
                  style={{
                    height: 700,
                    overflow: "hidden",
                    marginTop: 10,
                    padding: 25,
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  className="position-relative"
                  elevation={5}
                >
                  <ClusteredAmChart
                    targetData={targetData}
                    isMyPerformance={isMyPerformance}
                  />
                  {targetDataLoading && <Loader />}
                </Paper>
              )}

              {/* Target vs Achievement By Plan Type chart */}
              {hasSearched && (
                <Paper
                  style={{
                    overflow: "hidden",
                    marginTop: 10,
                    padding: 25,
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  className="position-relative"
                  elevation={5}
                >
                  {/* <div
                    style={{
                      display: "flex",
                      alignSelf: "baseline",
                      width: "100%",
                      justifyContent: "space-between",
                      padding: 30,
                    }}
                  >
                    <Typography variant="h5" component="h3">
                      {props.t("Target vs Achievement — By Plan Type")}
                    </Typography>
                  </div> */}
                  <TargetPerPlanChart
                    premiumData={targetPerPlanData.PREMIUM}
                    standardData={targetPerPlanData.STANDARD}
                    isMyPerformance={isMyPerformance} // ← add this
                  />
                  {targetPerPlanLoading && <Loader />}
                </Paper>
              )}
              {hasSearched &&
                (isOM || isAgent ? null : renderRegionwiseChart())}
              {hasSearched &&
                (isAgent
                  ? null
                  : selectedRegion
                    ? renderOutletwiseChart()
                    : null)}
              {hasSearched &&
                (isAgent
                  ? null
                  : selectedOutlet
                    ? renderEmployeewiseChart()
                    : null)}
            </TabPanel>
            <TabPanel value={value} index={1} className="tabPanelUI_style">
              <Paper
                style={{
                  overflow: "hidden",
                  marginTop: 10,
                  padding: 25,
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
                className="position-relative"
                elevation={5}
              >
                <div
                  style={{
                    display: "flex",
                    alignSelf: "baseline",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h5" component="h3">
                    {"Hayyak"}
                  </Typography>
                </div>
                {hayyakData?.total > 0 && hayyakData?.product == "HAYYAK" && (
                  <TraingleChart
                    tabIndex={value}
                    label={hayyakData?.label ?? []}
                    total={hayyakData?.total ?? 0}
                    ebuLabel={hayyakData?.ebuLabel}
                    cbuLabel={hayyakData?.cbuLabel}
                    ebuPlans={hayyakData?.ebuPlans}
                    cbuPlans={hayyakData?.cbuPlans}
                  />
                )}
                {hayyakData?.total == 0 && (
                  <Typography>No data found</Typography>
                )}
                {hayyakDataLoading && <Loader />}
              </Paper>
              {/* <MaterialTable
                  style={{ width: "100%", marginTop: 10 }}
                  icons={tableIcons}
                  columns={[
                    { title: props.t("Plan Name"), field: "name" },
                    { title: props.t("Sold Units"), field: "unit" },
                  ]}
                  data={
                    // hayyakData &&
                    // hayyakData.map((item) => {
                    //   return {
                    //     name: item.current_plan,
                    //     unit: item.qty,
                    //   };
                    // })
                    []
                  }
                  title={<h2></h2>}
                  options={{
                    search: false,
                  }}
                /> */}
            </TabPanel>
            <TabPanel value={value} index={2} className="tabPanelUI_style">
              <Paper
                style={{
                  overflow: "hidden",
                  marginTop: 10,
                  padding: 25,
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
                className="position-relative"
                elevation={5}
              >
                <div
                  style={{
                    display: "flex",
                    alignSelf: "baseline",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h5" component="h3">
                    {"Baqati"}
                  </Typography>
                </div>
                {baqatiData?.total > 0 && baqatiData?.product == "BAQATI" && (
                  <TraingleChart
                    tabIndex={value}
                    label={baqatiData?.label ?? []}
                    total={baqatiData?.total ?? 0}
                    ebuLabel={baqatiData?.ebuLabel}
                    cbuLabel={baqatiData?.cbuLabel}
                    ebuPlans={baqatiData?.ebuPlans}
                    cbuPlans={baqatiData?.cbuPlans}
                  />
                )}
                {baqatiData?.total == 0 && (
                  <Typography>No data found</Typography>
                )}
                {baqatiDataLoading && <Loader />}
              </Paper>
              {/* <Paper
                    style={{
                      height: 700,
                      overflow: "hidden",
                      marginTop: 10,
                      padding: 25,
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                    className="position-relative"
                    elevation={5}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignSelf: "baseline",
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="h5" component="h3">
                        {"Baqati"}
                      </Typography>
                    </div>
                    <BaqatiChart baqatiData={baqatiData} />{" "}
                    {baqatiDataLoading && <Loader />}
                  </Paper> */}
              {/* <MaterialTable
                  style={{ width: "100%", marginTop: 10 }}
                  icons={tableIcons}
                  columns={[
                    { title: props.t("Plan Name"), field: "name" },
                    { title: props.t("Sold Units"), field: "unit" },
                  ]}
                  data={
                    // baqatiData &&
                    // baqatiData?.map((item) => {
                    //   return {
                    //     name: item.current_plan,
                    //     unit: item.qty,
                    //   };
                    // })
                    []
                  }
                  title={
                    <h2>
                    </h2>
                  }
                  options={{
                    search: false,
                  }}
                /> */}
            </TabPanel>
            <TabPanel value={value} index={3} className="tabPanelUI_style">
              <Paper
                style={{
                  overflow: "hidden",
                  marginTop: 10,
                  padding: 25,
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
                className="position-relative"
                elevation={5}
              >
                <div
                  style={{
                    display: "flex",
                    alignSelf: "baseline",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h5" component="h3">
                    {"HBB"}
                  </Typography>
                </div>
                {hbbData?.total > 0 && hbbData?.product == "HBB" && (
                  <TraingleColumnChartHbb
                    label={hbbData?.label}
                    total={hbbData?.total}
                    cbuCategoryLabel={hbbData?.cbuCategoryLabel}
                    ebuCategoryLabel={hbbData?.ebuCategoryLabel}
                    subcateries={hbbData?.subcateries}
                    serviceCbuHbb={hbbData?.serviceCbuHbb}
                    serviceEbuHbb={hbbData?.serviceEbuHbb}
                    serviceCbuTotal={hbbData?.serviceCbuTotal}
                    serviceEbuTotal={hbbData?.serviceEbuTotal}
                    hbbPlans={hbbData?.hbbPlans}
                    getCategoryPlans={(product) => getCategoryPlans(product)}
                    categoryPlans={categoryPlans}
                  />
                )}
                {hbbData?.total == 0 && <Typography>No data found</Typography>}
                {hbbDataLoading && <Loader />}
              </Paper>
              {/* <MaterialTable
                  style={{ width: "100%", marginTop: 10 }}
                  icons={tableIcons}
                  columns={[
                    { title: props.t("Plan Name"), field: "name" },
                    { title: props.t("Sold Units"), field: "unit" },
                  ]}
                  data={
                    // hbbData &&
                    // hbbData.map((item) => {
                    //   return {
                    //     name: item.current_plan,
                    //     unit: item.qty,
                    //   };
                    // })
                    []
                  }
                  title={
                    <h2>
                    </h2>
                  }
                  options={{
                    search: false,
                  }}
                /> */}
            </TabPanel>

            <TabPanel value={value} index={4} className="tabPanelUI_style">
              <Paper
                style={{
                  height: 700,
                  overflow: "hidden",
                  marginTop: 10,
                  padding: 25,
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
                className="position-relative"
                elevation={5}
              >
                <div
                  style={{
                    display: "flex",
                    alignSelf: "baseline",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h5" component="h3">
                    {"Upgrade"}
                  </Typography>
                </div>
                <UpgradeChart upgradeData={upgradeData} />{" "}
                {upgradeDataLoading && <Loader />}
              </Paper>
              <MaterialTable
                style={{ width: "100%", marginTop: 10 }}
                icons={tableIcons}
                columns={[
                  { title: props.t("Plan Name"), field: "name" },
                  { title: props.t("Sold Units"), field: "unit" },
                ]}
                data={
                  upgradeData &&
                  upgradeData.map((item) => {
                    return {
                      name: item.current_plan,
                      unit: item.qty,
                    };
                  })
                }
                title={
                  <h2>
                    {/* <IntlMessages tagName="strong" id="Companies" /> */}
                  </h2>
                }
                options={{
                  search: false,
                }}
              />
            </TabPanel>
            <TabPanel value={value} index={5} className="tabPanelUI_style">
              <Paper
                style={{
                  // height: 700,
                  overflow: "hidden",
                  marginTop: 10,
                  padding: 25,
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
                className="position-relative"
                elevation={5}
              >
                <div
                  style={{
                    display: "flex",
                    alignSelf: "baseline",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h5" component="h3">
                    {"MNP"}
                  </Typography>
                </div>
                {MNPTotal > 0 ? (
                  <TraingleChart
                    tabIndex={value}
                    label={MNPlabel ?? []}
                    total={MNPTotal}
                    ebuLabel={hayyakLable}
                    cbuLabel={baqatiLable}
                    ebuPlans={hayyakPlan}
                    cbuPlans={baqatiPlan}
                    showMnpData={true}
                  />
                ) : (
                  <Typography>No data found</Typography>
                )}
                {hayyakDataLoading && <Loader />}
              </Paper>
              {/* <MaterialTable
                  style={{ width: "100%", marginTop: 10 }}
                  icons={tableIcons}
                  columns={[
                    { title: props.t("Plan Name"), field: "name" },
                    { title: props.t("Sold Units"), field: "unit" },
                  ]}
                  data={
                    // hayyakData &&
                    // hayyakData.map((item) => {
                    //   return {
                    //     name: item.current_plan,
                    //     unit: item.qty,
                    //   };
                    // })
                    []
                  }
                  title={<h2></h2>}
                  options={{
                    search: false,
                  }}
                /> */}
            </TabPanel>

            <TabPanel value={value} index={6} className="tabPanelUI_style">
              <Paper
                style={{
                  overflow: "hidden",
                  marginTop: 10,
                  padding: 25,
                  display: "flex",
                  flexDirection: "column",
                }}
                elevation={5}
              >
                {/* <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography variant="h5">Score Board</Typography>
                  <div id="summary-score-card">
                    Total Score : {SingleScore}/100
                  </div>
                </div> */}
                {quiz_score > 0 ? (
                  // <ScoreBoardPieChart data={getScorePieData()} />
                  <ScoreBoardTable
                    data={getScorePieData()}
                    totalScore={quiz_score}
                    quizData={quizData}
                  />
                ) : (
                  <Typography>No data found</Typography>
                )}
              </Paper>
            </TabPanel>
          </>
          {/* // ) : (
            //   <Paper
            //     style={{
            //       height: 700,
            //       overflow: "hidden",
            //       marginTop: 10,
            //       padding: 25,
            //       alignItems: "center",
            //       justifyContent: "center",
            //       display: "flex",
            //       flexDirection: "column",
            //     }}
            //     elevation={5}
            //   >
            //     {loader ? <Spinner /> : <Paper style={{ padding: 15, marginBottom: 30 }}>
            //       <Typography variant="h5" component="h3">
            //         {props.t("Search staff id to proceed")}
            //       </Typography>
            //     </Paper>}
                
            //   </Paper>
            // )} */}
        </div>
      </div>
    </>
  );
};

export default translate(StaffPerNew);
